<template>
  <div class="coop-c-hero coop-c-hero--squircle">
    <div class="coop-c-hero__inner coop-u-clearfix">
      <h1 class="coop-c-hero__title coop-u-padding-resp-t-32-24 coop-u-padding-resp-b-64-32">
        Thanks {{ surveyStore.surveyResult.name }}, we're preparing your checklist
      </h1>
      <div class="coop-c-hero__body coop-c-hero__body--close coop-u-padding-resp-t-48-24">
        <p class="coop-t-text-centre coop-u-text-alt">
          Processing answers...
        </p>
        <div class="coop-u-loading coop-u-margin-48-32 coop-u-flex coop-u-flex-centered">
          <svg
            width="103"
            height="112"
            viewBox="0 0 103 112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50.2164"
              cy="7.88732"
              r="7.88732"
              fill="#84EBF9"
            />
            <circle
              cx="78.8736"
              cy="96.2252"
              r="7.88732"
              fill="#E8FCFF"
            />
            <circle
              cx="94.6481"
              cy="39.4364"
              r="7.88732"
              fill="#E8FCFF"
            />
            <circle
              cx="94.6481"
              cy="69.4083"
              r="7.88732"
              fill="#E8FCFF"
            />
            <circle
              cx="51.2672"
              cy="104.113"
              r="7.88732"
              fill="#E8FCFF"
            />
            <circle
              cx="23.6617"
              cy="97.5397"
              r="7.88732"
              fill="#E1FBFF"
            />
            <circle
              cx="7.88732"
              cy="69.4083"
              r="7.88732"
              fill="#D5FAFF"
            />
            <circle
              cx="7.88732"
              cy="39.4364"
              r="7.88732"
              fill="#BAF7FF"
            />
            <circle
              cx="23.6617"
              cy="15.7748"
              r="7.88732"
              fill="#9CEEF9"
            />
          </svg>
        </div>
      </div>
    </div>
    <div
      class="coop-c-hero__decoration coop-c-hero__decoration--left"
      aria-hidden="true"
    >
      <svg
        width="66"
        height="227"
        viewBox="0 0 66 227"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-255.566 40.3585C-233.348 6.30694 -177.803 -6.97556 -135.058 5.58245C-92.0709 18.1404 -61.6419 56.2974 -25.1754 90.3489C11.5326 124.642 54.2781 155.071 63.4551 194.677C72.8736 234.283 48.4821 283.066 11.7741 307.216C-24.9339 331.366 -73.7169 330.641 -114.772 322.672C-155.585 314.944 -188.912 299.971 -211.13 275.821C-233.59 251.912 -245.182 218.585 -256.291 174.391C-267.4 130.196 -278.026 74.6515 -255.566 40.3585Z"
          fill="#84EBF9"
        />
      </svg>
    </div>
    <div
      class="coop-c-hero__decoration coop-c-hero__decoration--bottom"
      aria-hidden="true"
    >
      <svg
        width="179"
        height="304"
        viewBox="0 0 179 304"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M58.0465 470.278C8.20304 437.756 -11.2395 356.451 7.14253 293.882C25.5246 230.959 81.3776 186.418 131.221 133.04C181.418 79.3075 225.959 16.7381 283.933 3.30507C341.907 -10.4814 413.314 25.2221 448.664 78.9541C484.014 132.686 482.954 204.093 471.288 264.188C459.976 323.93 438.059 372.713 402.709 405.235C367.713 438.11 318.93 455.078 254.239 471.339C189.549 487.6 108.244 503.154 58.0465 470.278Z"
          fill="#84EBF9"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';

const surveyStore = useSurveyStore();

const currentUrl = window.location.href.split('?')[0].split('#')[0];
const urlParameter = `?id=${surveyStore.encodeUrlParams()}`;
window.history.pushState({}, '', currentUrl + urlParameter);

onMounted(() => {
  setTimeout(() => {
    surveyStore.mode = 'checklist';
    window.dataLayer.push({
      event: 'pageview',
      pagePath: window.location.pathname + window.location.search + window.location.hash,
      pageTitle: document.title,
    });
  }, 2000);
});
</script>
